export const OrgScopedPathPatterns: ReadonlyArray<string> = [
  '/announcements',
  '/analysis/:analysisId',
  '/dashboard',
  '/dashboard/customer',
  '/patients',
  '/patients/:patientId',
  '/projects',
  '/projects/:projectId',
  '/members',
  '/members/invitations',
  '/requests',
  '/requests/:practiceRequestId',
  '/dropbox',
  '/faxes',
]
